module.exports = __webpack_public_path__ + "img/nav-design-diamonds.8e2628a.jpg";